import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { RiAppsLine } from '@remixicon/react';

// A routeRef is required for the page to be picked up by AppNav and become
// available to `nav.take('page:service-portal')` in the sidebar.
const servicePortalRouteRef = createRouteRef();

const servicePortalPage = PageBlueprint.make({
  params: {
    path: '/service-portal',
    title: 'Service Portal',
    icon: <RiAppsLine />,
    routeRef: servicePortalRouteRef,
    loader: async () => {
      const { ServicePortalPage } = await import(
        '../components/service-portal/ServicePortalPage'
      );
      return compatWrapper(<ServicePortalPage />);
    },
  },
});

const servicePortalTeamPage = PageBlueprint.make({
  name: 'team',
  params: {
    path: '/service-portal/:teamId',
    title: 'Service Portal',
    icon: <RiAppsLine />,
    loader: async () => {
      const { TeamServicePortalPage } = await import(
        '../components/service-portal/TeamServicePortalPage'
      );
      return compatWrapper(<TeamServicePortalPage />);
    },
  },
});

const awsAccessPage = PageBlueprint.make({
  name: 'aws-access',
  params: {
    path: '/service-portal/platform-engineering/aws-access',
    title: 'Service Portal',
    icon: <RiAppsLine />,
    loader: async () => {
      const { AwsAccessIndexPage } = await import(
        '../components/aws-access/AwsAccessIndexPage'
      );
      return compatWrapper(<AwsAccessIndexPage />);
    },
  },
});

const awsAccessAccountPage = PageBlueprint.make({
  name: 'aws-access-account',
  params: {
    path: '/service-portal/platform-engineering/aws-access/:accountId',
    title: 'Service Portal',
    icon: <RiAppsLine />,
    loader: async () => {
      const { AwsAccessPage } = await import(
        '../components/aws-access/AwsAccessPage'
      );
      return compatWrapper(<AwsAccessPage />);
    },
  },
});

export default createFrontendPlugin({
  pluginId: 'service-portal',
  routes: {
    root: servicePortalRouteRef,
  },
  extensions: [
    servicePortalPage,
    servicePortalTeamPage,
    awsAccessPage,
    awsAccessAccountPage,
  ],
});
